import React, { useState } from 'react'
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Route, Switch, useHistory } from 'react-router-dom'
import TextField from '@material-ui/core/TextField';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import TestInstructions from './TestInstructions';
import Copyright from '../common/copyright';
import header from "../../assets/images/registrationHeader.png";
import { Alert, AlertTitle } from '@material-ui/lab';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import RegisterSRNumber from '../common/registerSrNumber';


export default function SrNoValidation({ validateSRNumber, setTextInputValue, error, data,
    // studentName, parentName, srNumberForPost, mobileNumber, diseCode, 
    registerSRNumber, open
}) {

    const classes = useStyles();

    const history = useHistory();

    const [srNumber, setSrNumber] = useState('');
    const [navParams, setNavParams] = useState('');
    const [showRegistration, setShowRegistration] = useState(false)
    const [studentName, setStudentName] = useState('')
    const [parentName, setParentName] = useState('')
    const [srNumberPost, setSRNumberPost] = useState('')
    const [mobileNumber, setMobileNumber] = useState('')
    const [diseCode, setDiseCode] = useState('')




    const doNavigation = () => {
        console.log('status',)

        history.push({ pathname: "/instructions", search: '?query=abc', state: { data: navParams } })
        // if(status){
        //     history.push("/instructions")
        // }
        // else{
        //     history.push("/instructions")
        // }
    }

    function showError() {
        if (error) {
            return (
                <Alert severity="error">
                    <AlertTitle>Please Enter Valid SR Number</AlertTitle>
                </Alert>
            )
        }
    }

    const handleRegistration = (sName, classId, ptName, srNumberForPost, mNumber, dCode) => {
        // console.log("registerSRNumber",sName, ptName, srNumberForPost, mNumber, dCode  )n
        if (sName != "" && classId != "" && ptName != "" && srNumberForPost != "" && mNumber != "") {
            setShowRegistration(false)
            registerSRNumber(sName, classId, ptName, srNumberForPost, mNumber, dCode)
        }
    }

    function handleClickOpen() {
        setShowRegistration(true)
    }

    function showServerError() {
        if (error) {
            return (
                <Alert severity="error">
                    <AlertTitle>Please try after some time.</AlertTitle>
                </Alert>
            )
        }
    }

    return (
        <div className={classes.root}>
            {/* <Header></Header> */}
            <Container component="main" maxWidth="xs" className={classes.authContainer}>
                <Switch>
                    <Route path="/instructions" component={TestInstructions} />
                </Switch>
                <CssBaseline />
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <form className={classes.form} onSubmit={validateSRNumber}>
                        {/* onSubmit={validate} */}
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="srNumber"
                            label="SR Number"
                            name="srNumber"
                            autoComplete="email"
                            autoFocus
                            onChange={(value) => {
                                // setSrNumber(value.target.value)
                                // console.log(value.target.value)
                                setTextInputValue(value.target.value)
                            }}
                        />

                        {/* <Typography>{showResult()}</Typography> */}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                        // onClick={validate}
                        >

                            Click here for assessment

                        </Button>
                    </form>
                    {/* <Button variant="outlined" color="primary" onClick={handleClickOpen}>
                        Register for SRNumber
                    </Button> */}
                    {/* <RegisterSRNumber
                        open={showRegistration}
                        data={data}
                        handleClose={() => setShowRegistration(false)}
                        // studentName={setStudentName()}
                        // parentName={parentName}
                        // srNumber={srNumberPost}
                        // mobileNumber={mobileNumber}
                        // diseCode={diseCode}
                        handleRegistration={handleRegistration}
                    /> */}
                    {
                        showError()
                    }
                </div>

            </Container >
            <Backdrop className={classes.backdrop} open={open}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <footer className={classes.footer}>
                <Container maxWidth="sm">
                    <Copyright />
                </Container>
            </footer>
        </div >
    );
}

const useStyles = makeStyles((theme) => ({

    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundImage: `url(${header})`,
        //backgroundSize: 'cover',
        alignItems: 'center',
        backgroundPositionY: '-150px',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto',
        backgroundColor: "#fff"
    },
    authContainer: {
        marginTop: '150px'
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        BackgroundColor: "#eccc15"
    },
    footer: {
        padding: theme.spacing(3, 2),
        marginTop: 'auto',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));
